// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"06866269","658":"2d4c5d23","660":"06866269","742":"06866269","752":"a9f34bd0","943":"6ef51004","970":"06866269"}[chunkId] + ".chunk.css";
};